// extracted by mini-css-extract-plugin
export default {"container":"CoverButtonLayout_container__GQHR6","card":"CoverButtonLayout_card__deGAO","title":"CoverButtonLayout_title__oJ8Xe","image":"CoverButtonLayout_image__eSz1T"};